// Case detail page translation (canvas list)
export default {
  // Page title
  pageTitle: "Case Details",

  // Top action buttons
  buttons: {
    edit: "Edit",
    delete: "Delete",
  },

  // Tabs
  tabs: {
    canvasAnalysis: "Canvas Analysis",
    dataBoard: "Data Dashboard",
    surveyManage: "Investigation Recommendations",
    surveyUser: "Investigation Users",
    addressMonitor: "Address Monitor",
    keyAddress: "Key Address",
    characterInfo: "Character Info",
    remarkManagement: "Remark Management",
  },

  // Confirm dialog
  confirmDialog: {
    deleteTitle: "Confirmation",
    deleteMessage:
      "This operation will permanently delete the canvas {caseName}, are you sure?",
    confirmButton: "Confirm",
    cancelButton: "Cancel",
  },

  // Message prompts
  messages: {
    deleteSuccess: "Deleted successfully!",
    deleteCancelled: "Deletion cancelled",
  },
};
